import { render, staticRenderFns } from "./supplyChainConfig.vue?vue&type=template&id=610eeb78&scoped=true&"
import script from "./supplyChainConfig.vue?vue&type=script&lang=js&"
export * from "./supplyChainConfig.vue?vue&type=script&lang=js&"
import style0 from "./supplyChainConfig.vue?vue&type=style&index=0&id=610eeb78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610eeb78",
  null
  
)

export default component.exports